import type { PlainSecret } from "@/queries/secret-queries";
import { Timestamp } from "@bufbuild/protobuf";

/** Resolve the mount type to a human-readable label. */
export function mountTypeLabel(secret: PlainSecret): string {
    switch (secret.mount.case) {
        case "environmentVariable":
            return "Environment Variable";
        case "filePath":
            return "File";
        case "containerRegistryBasicAuthHost":
            return "Container Registry Basic Auth";
        case "apiOnly":
            return "API Only";
        default:
            return "";
    }
}

/** Resolve the last-updated date from a secret. */
export function lastUpdatedDate(secret: PlainSecret): Date | undefined {
    const ts = secret.updatedAt || secret.createdAt;
    if (!ts) return undefined;
    return new Timestamp(ts).toDate();
}
